var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcValidated = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "120px",
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C5AE5D1B-1EFF-4473-B7F1-82EAC0459416") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "POC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02.00.06-Submitted",
    transform: "translate(-120.000000, -258.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Feedback",
    transform: "translate(24.000000, 258.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tick_hi",
    transform: "translate(96.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    fillOpacity: 0,
    fill: "#D8D8D8",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3375,100 C45.75,100 43.49375,97.36875 42.275,95.93125 L17.325,68.3 L17.25,68.2125 L16.74375,67.5875 C16.6904459,67.5233766 16.6403833,67.4566265 16.59375,67.3875 C15.5161354,65.9090083 14.9559776,64.1165032 15,62.2875 C15.006883,57.8582691 18.5957691,54.269383 23.025,54.2625 C25.16875,54.2625 27.19375,55.1875 29.04375,57.01875 L47.4375,73.0125 L87.2625,22.5 C88.5625,20.59375 90.475,18.4375 93.76875,18.4375 C97.819711,18.4409462 101.102804,21.724039 101.10625,25.775 C101.033389,27.4800643 100.427926,29.1194065 99.375,30.4625 L65.575,82.15 L65.575,82.18125 L56.875,95 C55.71875,96.65 53.3875,100 49.3375,100 Z",
    id: "Shape",
    fill: "#E60000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.375,29.09375 L65.575,80.78125 L65.575,80.8125 L56.875,93.65 C55.73125,95.28125 53.4,98.60625 49.375,98.60625 C45.7875,98.60625 43.53125,95.975 42.3125,94.5375 L17.325,66.93125 L17.25,66.875 L16.74375,66.25 C16.6904459,66.1858766 16.6403833,66.1191265 16.59375,66.05 C15.6629912,64.7718104 15.1185311,63.2533956 15.025,61.675 C15.025,61.85 15.025,62.01875 15.025,62.19375 C14.9782088,64.0270009 15.5385032,65.8243374 16.61875,67.30625 C16.6653833,67.3753765 16.7154459,67.4421266 16.76875,67.50625 L17.275,68.13125 L17.35,68.21875 L42.275,95.8125 C43.525,97.25 45.75,99.88125 49.3375,99.88125 C53.3875,99.88125 55.71875,96.55625 56.8375,94.925 L65.53125,82.09375 L65.53125,82.0625 L99.375,30.375 C100.427926,29.0319065 101.033389,27.3925643 101.10625,25.6875 C101.10625,25.45625 101.10625,25.23125 101.06875,25.00625 C100.868629,26.4926964 100.284894,27.9014145 99.375,29.09375 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.80625,97.55625 L43.18125,96.93125 C43.38125,97.14375 43.5875,97.35 43.80625,97.55625 Z",
    id: "Shape",
    fill: "#E60000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.55,21.25 C98.1558411,19.4657514 96.0143141,18.4272954 93.75,18.4374255 C90.45625,18.4374255 88.54375,20.59375 87.24375,22.5 L80.825,30.66875 L98.89375,20.625 L99.55,21.25 Z",
    id: "Shape",
    fill: "#E60000",
    fillRule: "nonzero"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcValidated);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_validated.a758bcae3694686cdba494e7b9305831.svg";